import {BumpDatum} from '@nivo/bump'

// top ten block response

export interface TopTenBlocksResponseBody {
  message: string
  response: TopTenBlocksResponse[]
}
export interface TopTenBlocksResponse {
  name: string
  email: string | null
  entityType: string
  policyViolations: number
  malwareBlocks: number
  cacBlocks: number
}

// policy violation summary response

export interface PolicyViolationSummaryResponseBody {
  message: string
  response: PolicyViolationSummaryResponse
}
export interface PolicyViolationSummaryResponse {
  policy: PolicySummary
  malware: MalwareSummary
  cac: CACSummary
}

export interface CACSummary {
  totalBlocks: number
  details: CloudAppControlDetail[]
}

export interface CloudAppControlDetail {
  cloudApp: string
  blocks: number
}

export interface MalwareSummary {
  totalBlocks: number
  details: MalwareDetail[]
}

export interface MalwareDetail {
  name: string
  blocks: number
}

export interface PolicySummary {
  totalViolations: number
  details: PolicyDetail[]
}

export interface PolicyDetail {
  categoryName: string
  violations: number
}

// policy violation transactions response
export interface PolicyViolationTransactionsResponse {
  policy: PolicyTransactions
  malware: MalwareFileScanned
  cloudAppControl: CACTransactions
  a7DayTrendBlocks: A7DayTrendBlock[]
}

export interface A7DayTrendBlock {
  date: string
  policyViolations: number
  malwareBlocks: number
  cloudAppControl: number
}

export interface A7DayTrendChartSeries {
  id: string
  name: string
  data: BumpDatum[]
}

export interface CACTransactions {
  totalTransactions: number
}

export interface MalwareFileScanned {
  filesScanned: number
}

export interface PolicyTransactions {
  totalTransactions: number
}

// Redux state interfaces
export interface TopTenBlocksState extends TopTenBlocksResponse {
  totalBlocks: number
}

export interface AnalyticsPolicy7DayTrendState {
  policy: PolicySummary & PolicyTransactions
  malware: MalwareSummary & MalwareFileScanned
  cloudAppControl: CACSummary & CACTransactions
  a7DayTrendBlocks: A7DayTrendBlock[]
}

// Redux action interfaces

export interface GetTopTenBlocksAction {
  filter: GetTopTenBlocksActionFilter
}

export interface GetTopTenBlocksActionFilter {
  policyTypes: string[]
  resources: string[]
}

export enum POLICY_TYPE {
  Policy = 'web_policy',
  Malware = 'malware',
  CAC = 'cac',
}

export enum POLICY_VERDICT {
  Verdict1 = 'Blocked',
  Verdict2 = 'Warning',
}

export enum RESOURCE_TYPE {
  Users = 'users',
  Location = 'location',
  Groups = 'groups',
}

// remove this once, API supports consistent resource type value
export enum RESOURCE_TYPE_SINGULAR {
  User = 'user',
  Location = 'location',
  Group = 'group',
}

export enum POLICY_TYPE_MAPPING {
  web_policy = 'Policy',
  cac = 'CAC',
  malware = 'Malware',
}
